import { ClassifierValue } from "types/classifier";

export const formatClassifiterWithGroupName = (classifier: ClassifierValue) => {
  if (!classifier.groupName) {
    return classifier.valueName;
  }

  return `${classifier.groupName} | ${classifier.valueName}`;
};
